<template>
    <div>
        <b-card-header v-b-toggle.secondary-seller-information>
            STEP 4 - Secondary Seller Information
        </b-card-header>
        <b-collapse id="secondary-seller-information">
            <b-card>
                <b-row>
                    <b-col cols="6">
                        <b-form-group>
                            <label>Secondary First Name</label>
                            <b-form-input v-model="secondary.firstName" placeholder="Enter Secondary Sellers First Name"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group>
                            <label>Secondary Last Name</label>
                            <b-form-input v-model="secondary.lastName" placeholder="Enter Secondary Sellers Last Name"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group>
                            <label>Secondary Email</label>
                            <b-form-input v-model="secondary.email" placeholder="Enter Secondary Sellers Email Address"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
                        <b-form-group>
                            <label>Secondary Phone</label>
                            <b-form-input v-model="secondary.phone" placeholder="Enter Secondary Sellers Phone Number"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card>
        </b-collapse>
    </div>
</template>
<script>

export default {
    name: 'SecondarySellerInformation',
    props:{
        secondary:{
            type: Object,
            default:{
                email: null,
                firstName: null,
                lastName: null,
                phone: null
            }
        }
    }
}
</script>
